import styled, { css } from 'styled-components';

import { rem } from '../../libs';
import InputButtonPrimitive from '../Input/primitives/InputButtonPrimitive';

export const Root = styled.label<{ $isDisabled: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  gap: ${({ theme }) => theme.core.spacing['4x']};

  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  user-select: none;
`;

export const CircleContainer = styled.div<{ $isChecked: boolean }>(
  ({ theme, $isChecked }) => {
    const variant = theme.components.SimpleToggle.on;

    return css`
      box-sizing: border-box;
      position: relative;
      width: ${rem(56)};
      height: ${rem(32)};
      background: ${$isChecked ? variant['bg-on'] : variant['bg-off']};
      border-radius: ${variant.radius};
      outline: none;

      &:has(input:focus-visible) {
        outline: 4px solid ${variant.shadow};
      }
    `;
  },
);

export const Circle = styled.span<{ $isChecked: boolean }>(
  ({ theme, $isChecked }) => {
    const variant = theme.components.SimpleToggle.on;

    const padding = theme.core.spacing['2x'];

    return css`
      box-sizing: border-box;
      position: absolute;
      top: ${padding};

      ${$isChecked ? `right: ${padding};` : `left: ${padding};`}

      width: ${theme.core.iconSize.m};
      height: ${theme.core.iconSize.m};
      background: ${$isChecked
        ? variant['indicator-on']
        : variant['indicator-off']};
      border-radius: ${theme.core.radius.full};
    `;
  },
);

export const InputElement = styled(InputButtonPrimitive)`
  margin: 0;
  appearance: none;
`;
